import { Injectable } from "@angular/core";
import { Service } from "src/app/core/jsonapi/service";
import { Country } from "../_types/country";
import { CountryRegion } from "../_types/country-region";
@Injectable({
  providedIn: 'root',
})

export class CountriesRegionsService extends Service<CountryRegion> {
  public override type = 'countriesRegions';
  public override url = 'common/countryRegions';
  
  //habilita la cache para el metodo all
  public override CACHEABLE_METHODS: any = { all: true };
}
